import transporApi from '@/api/transport/transport-api';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async add({dispatch}, form) {
      try {
        await transporApi.add(form);
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchSummary(_, {slaughterWeekId}) {
      try {
        const response = await transporApi.fetchSummary(slaughterWeekId);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async delete(_, {id}) {
      try {
        await transporApi.delete(id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error.response.data);
      }
    },
    async move({dispatch}, form) {
      try {
        await transporApi.move(form);
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async split(_, form) {
      try {
        await transporApi.split(form);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error.response.data);
      }
    },
    async update({dispatch}, form) {
      try {
        await transporApi.update(form);
        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
  }
}
